module.exports = __webpack_public_path__ + "static/media/sqlite.d322ff82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sqlite.png
// module id = 194
// module chunks = 0